import React, { Component } from "react";
import _ from "lodash";

class AdminSummaryList extends Component {
  state = {
    cancelled: false,
    delivered: false,
    data: {
      path: "adminSummary",
      payload: {}
    }
  };

  getSubTableRows = (names, mobiles, qtys) => {
    if (names && names.length > 0) {
      return names.map((name, index) => {
        return (
          <tr>
            <td>{name}</td>
            <td>{mobiles[index]}</td>
            <td>{qtys[index]}</td>
          </tr>
        );
      });
    }
  };

  getPoSubTableRows = (qtyGroups, units) => {
    if (qtyGroups && qtyGroups !== undefined && qtyGroups.length > 0) {
      return qtyGroups.map((qtg, index) => {
        return (
          <tr>
            <td>
              {qtg.bucketSize} x {units[0]}
            </td>
            <td>{qtg.bucketFrequency}</td>
          </tr>
        );
      });
    }
  };

  getBasicRow = (
    label,
    value,
    orderNames,
    orderPhones,
    orderQtys,
    photos,
    totAmount,
    price,
    qtyGroups,
    unit
  ) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginLeft: "5px",
            marginRight: "5px",
            padding: "5px",
            fontSize: "14px",
            fontWeight: "bold"
          }}
        >
          <div
            style={{
              width: "80%",
              textAlign: "left"
            }}
          >
            {label.toUpperCase()}
          </div>
          <div
            style={{
              width: "20%",
              textAlign: "right",
              overflow: "scroll"
            }}
          >
            {value}
          </div>
        </div>
        {this.props.image && (
          <div>
            <img
              src={photos && photos.length > 0 ? photos[0].url : ""}
              style={{
                maxWidth: "250px",
                maxHeight: "250px",
                height: "200px",
                width: "200px",
                borderRadius: "0px",
                border: this.state[0] ? "1px solid gainsboro" : "0px",
                objectFit: "contain",
                margin: this.state[0] ? "5px" : "0px",
                minWidth: this.state[0] ? "250px" : null
              }}
            />
          </div>
        )}
        <hr
          style={{
            margin: "0px"
          }}
        />
        {this.props.breakup && (
          <div
            style={{
              fontSize: "10px",
              padding: "5px"
            }}
          >
            {!this.props.poMode && (
              <table className="table table-striped tabled-bordered table-sm">
                <thead>
                  <tr>
                    <td>Name</td>
                    <td>Mobile</td>
                    <td>Quantity</td>
                  </tr>
                </thead>
                <tbody>
                  {this.getSubTableRows(orderNames, orderPhones, orderQtys)}
                </tbody>
              </table>
            )}
            {this.props.poMode && (
              <table className="table table-striped tabled-bordered table-sm">
                <thead>
                  <tr>
                    <td>Size</td>
                    <td>No. of packets</td>
                  </tr>
                </thead>
                <tbody>{this.getPoSubTableRows(qtyGroups, unit)}</tbody>
              </table>
            )}
          </div>
        )}
      </div>
    );
  };

  getSummaryCard = (rec, srNo) => {
    //console.log(JSON.stringify(rec.qtyGroups));
    return (
      <div>
        {this.getBasicRow(
          srNo + ". " + rec.productName + " (" + rec.unit[0] + ")",
          rec.totalQuantity,
          rec.name,
          rec.mobile,
          rec.subQuantities,
          rec.photos,
          rec.totAmount,
          rec.price,
          rec.qtyGroups,
          rec.unit
        )}
      </div>
    );
  };

  getDetailList = processedArray => {
    return processedArray.map((rec, index) => {
      return this.getSummaryCard(rec, index + 1);
    });
  };

  getSummaryItems = data => {
    let processedArray = data.products;

    if (processedArray && processedArray.length > 0) {
      return (
        <div>
          <div>{this.getDetailList(processedArray)}</div>
        </div>
      );
    }
  };

  render() {
    if (
      this.props.data &&
      this.props.data !== undefined &&
      this.props.data.length > 0
    ) {
      return (
        <div
          style={{
            borderRadius: "10px",
            backgroundColor: "white",
            margin: "5px",
            padding: "10px",
            marginBottom: "15px",
            fontSize: "12px",
            fontWeight: "bold",
            border: "1.5px solid #ccc",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
          }}
        >
          <div>{this.getSummaryItems(this.props.summedData)}</div>
        </div>
      );

      //return this.getRows(this.props.data);
    } else {
      if (this.props.dataIsLoaded) {
        return (
          <div
            style={{
              borderRadius: "10px",
              backgroundColor: "white",
              margin: "5px",
              padding: "10px",
              marginBottom: "15px",
              fontSize: "12px",
              fontWeight: "bold",
              border: "1.5px solid #ccc",
              boxSizing: "border-box",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              textAlign: "center"
            }}
          >
            No orders available to display.
          </div>
        );
      } else {
        return (
          <div
            style={{
              borderRadius: "10px",
              backgroundColor: "white",
              margin: "5px",
              padding: "10px",
              marginBottom: "15px",
              fontSize: "12px",
              fontWeight: "bold",
              border: "1.5px solid #ccc",
              boxSizing: "border-box",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              textAlign: "center"
            }}
          >
            <div
              style={{
                textAlign: "center"
              }}
            >
              Seems like you are on a slow network, we are loading data please
              wait a moment...
            </div>
          </div>
        );
      }
    }
  }
}

export default AdminSummaryList;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/AdminSummaryList.jsx